export default __webpack_public_path__ + "static/media/business.bd536af4.png";